export enum RestApiPayloadType {
	JSON,
	FormData,
	EncodedFormData,
}
